import { render, staticRenderFns } from "./CoverPriceDetails.vue?vue&type=template&id=41f48c2a"
import script from "./CoverPriceDetails.vue?vue&type=script&lang=js"
export * from "./CoverPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./CoverPriceDetails.vue?vue&type=style&index=0&id=41f48c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports